import React from 'react';
import PropTypes from 'prop-types';
import SignUpButton from '../sign-up-button';
import SignInButton from '../sign-in-button';
import MenuToggle from './menu-toggle';
import SearchBar from '../search-bar';

export default function Header({ isUserSignedIn }) {
  return (
    <header>
      <MenuToggle />
      <a className="logo" href="/" id="mobile-nav-logo">
        <span className="icon-lw icon-lw-logo" />
      </a>
      <section className="navigation">
        {!isUserSignedIn && (
          <React.Fragment>
            <SignInButton />
            <SignUpButton />
          </React.Fragment>
        )}
        <SearchBar isMobile isUserSignedIn={isUserSignedIn} />
      </section>
    </header>
  );
}

Header.propTypes = {
  isUserSignedIn: PropTypes.bool.isRequired,
};
